import { z } from "zod";
import { SAMPLE_TYPES } from "@typings/entities/samples/enums";
import { config } from "@/config";
import type { DefaultValues } from "react-hook-form";
import { VisitTypeHelper } from "@typings/entities/visit/enums";

export const visitSchema = z.object({
  visitType: z
    .enum(VisitTypeHelper.getKeys(), {
      message: "Tipo de Visita deve ser um valor válido",
    })
    .nullable()
    .optional(),
  date: z.string().min(1, "Data é obrigatória"),
  responsibleTeam: z.string().min(1, "Equipe Responsável é obrigatória"),
  sampleTypes: z.array(z.enum(SAMPLE_TYPES)).optional(),
  formAttachments: z
    .array(z.instanceof(File))
    .max(
      config.uploadArchive.maxFiles,
      `Você pode enviar no máximo ${config.uploadArchive.maxFiles} arquivos.`,
    )
    .optional(),
  photoReportAttachments: z
    .array(z.instanceof(File))
    .max(
      config.uploadArchive.maxFiles,
      `Você pode enviar no máximo ${config.uploadArchive.maxFiles} arquivos.`,
    )
    .optional(),
});

export type VisitFormData = z.infer<typeof visitSchema>;

export const visitDefaultValues: DefaultValues<VisitFormData> = {
  visitType: undefined,
  date: "",
  responsibleTeam: "",
  sampleTypes: undefined,
  formAttachments: [],
  photoReportAttachments: [],
};
